const defaultProducts = [
  {
    productId: "ludo_1000_coins",
    title: "1000 Coins",
    description: "1,000 Ludo Voice Coins",
    price: "0.99",
    currency: "USD",
    localizedPrice: "$0.99",
  },
  {
    productId: "ludo_5000_coins",
    title: "5000 Coins",
    description: "5,000 Ludo Voice Coins",
    price: "4.99",
    currency: "USD",
    localizedPrice: "$4.99",
  },
  {
    productId: "ludo_10000_coins",
    title: "10000 Coins",
    description: "10,000 Ludo Voice Coins",
    price: "9.99",
    currency: "USD",
    localizedPrice: "$9.99",
  },
  {
    productId: "ludo_25000_coins",
    title: "25000 Coins",
    description: "25,000 Ludo Voice Coins",
    price: "19.99",
    currency: "USD",
    localizedPrice: "$19.99",
  },
  {
    productId: "ludo_75000_coins",
    title: "75000 Coins",
    description: "75,000 Ludo Voice Coins",
    price: "49.99",
    currency: "USD",
    localizedPrice: "$49.99",
  },
  {
    productId: "ludo_200000_coins",
    title: "200000 Coins",
    description: "200,000 Ludo Voice Coins",
    price: "99.99",
    currency: "USD",
    localizedPrice: "$99.99",
  },
];

function showPaymentModal(product) {
  return new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      resolve({
        productId: product.productId,
        transactionId: 'web_' + Date.now(),
        transactionDate: Date.now(),
        transactionReceipt: 'web_receipt_' + Date.now(),
        purchaseToken: 'web_token_' + Date.now(),
      });
      return;
    }

    const existing = document.getElementById('google-play-checkout-modal');
    if (existing) existing.remove();

    const modal = document.createElement('div');
    modal.id = 'google-play-checkout-modal';
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.7);
      z-index: 999999;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      animation: fadeIn 0.2s ease-out;
    `;

    modal.innerHTML = `
      <style>
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
      </style>
      <div style="
        width: 100%;
        max-width: 480px;
        background: #202124;
        color: #fff;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 24px;
        box-shadow: 0 -8px 24px rgba(0,0,0,0.5);
        animation: slideUp 0.3s ease-out;
      ">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3.6 1.8L13.7 12 3.6 22.2C3.2 21.8 3 21.2 3 20.5V3.5C3 2.8 3.2 2.2 3.6 1.8Z" fill="#00D3FF"/>
              <path d="M17.1 8.6L13.7 12 3.6 1.8C4.1 1.4 4.8 1.3 5.5 1.7L17.1 8.6Z" fill="#00F076"/>
              <path d="M17.1 15.4L5.5 22.3C4.8 22.7 4.1 22.6 3.6 22.2L13.7 12L17.1 15.4Z" fill="#FF3A44"/>
              <path d="M21.2 10.9L17.1 8.6L13.7 12L17.1 15.4L21.2 13.1C22.3 12.5 22.3 11.5 21.2 10.9Z" fill="#FFC800"/>
            </svg>
            <span style="font-size: 16px; font-weight: 600; color: #e8eaed;">Google Play</span>
          </div>
          <button id="iap-close-btn" style="background: none; border: none; color: #9aa0a6; font-size: 20px; cursor: pointer; padding: 4px;">✕</button>
        </div>

        <div style="display: flex; align-items: center; gap: 16px; background: #303134; padding: 16px; border-radius: 12px; margin-bottom: 20px;">
          <div style="font-size: 36px;">🪙</div>
          <div style="flex: 1;">
            <div style="font-size: 17px; font-weight: 700; color: #fff;">${product.title}</div>
            <div style="font-size: 13px; color: #9aa0a6;">Ludo Voice In-App Purchase</div>
          </div>
          <div style="font-size: 20px; font-weight: 700; color: #8ab4f8;">${product.localizedPrice}</div>
        </div>

        <div style="background: #2d2f31; padding: 12px 16px; border-radius: 10px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <span style="font-size: 20px;">💳</span>
            <div>
              <div style="font-size: 14px; color: #e8eaed; font-weight: 500;">Google Pay · Visa •••• 4242</div>
              <div style="font-size: 11px; color: #9aa0a6;">instant token balance credit</div>
            </div>
          </div>
          <span style="font-size: 12px; color: #8ab4f8; font-weight: 500;">Primary</span>
        </div>

        <button id="iap-buy-btn" style="
          width: 100%;
          padding: 16px;
          background: #00875a;
          color: #fff;
          border: none;
          border-radius: 28px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: background 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        ">
          1-Tap Buy
        </button>

        <p style="text-align: center; font-size: 11px; color: #9aa0a6; margin-top: 14px; margin-bottom: 0;">
          By tapping "1-Tap Buy", you agree to Google Play Terms of Service.
        </p>
      </div>
    `;

    document.body.appendChild(modal);

    const closeBtn = modal.querySelector('#iap-close-btn');
    const buyBtn = modal.querySelector('#iap-buy-btn');

    closeBtn.onclick = () => {
      modal.remove();
      reject(new Error('User cancelled purchase'));
    };

    buyBtn.onclick = () => {
      buyBtn.innerText = 'Processing...';
      buyBtn.style.opacity = '0.7';
      buyBtn.disabled = true;

      setTimeout(() => {
        modal.remove();
        resolve({
          productId: product.productId,
          transactionId: 'web_' + Date.now(),
          transactionDate: Date.now(),
          transactionReceipt: 'web_receipt_' + Date.now(),
          purchaseToken: 'web_token_' + Date.now(),
        });
      }, 1000);
    };
  });
}

const initConnection = async () => true;
const endConnection = async () => {};
const getProducts = async ({ skus } = {}) => {
  if (Array.isArray(skus) && skus.length > 0) {
    return defaultProducts.filter(p => skus.includes(p.productId));
  }
  return defaultProducts;
};
const getSubscriptions = async () => defaultProducts;

const requestPurchase = async (params) => {
  const productId = params?.sku || params?.skus?.[0] || 'ludo_1000_coins';
  const product = defaultProducts.find(p => p.productId === productId) || {
    productId,
    title: productId.replace(/_/g, ' '),
    localizedPrice: '$0.99',
  };

  return showPaymentModal(product);
};

const requestSubscription = async (params) => requestPurchase(params);
const finishTransaction = async ({ purchase } = {}) => {
  return { status: 1, message: 'Transaction finished' };
};
const purchaseUpdatedListener = (cb) => ({ remove: () => {} });
const purchaseErrorListener = (cb) => ({ remove: () => {} });
const flushFailedPurchasesCachedAsPendingAndroid = async () => {};

module.exports = {
  initConnection,
  endConnection,
  getProducts,
  getSubscriptions,
  requestPurchase,
  requestSubscription,
  finishTransaction,
  purchaseUpdatedListener,
  purchaseErrorListener,
  flushFailedPurchasesCachedAsPendingAndroid,
  default: {
    initConnection,
    endConnection,
    getProducts,
    getSubscriptions,
    requestPurchase,
    requestSubscription,
    finishTransaction,
    purchaseUpdatedListener,
    purchaseErrorListener,
    flushFailedPurchasesCachedAsPendingAndroid,
  },
};
